import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { DialogTitle } from 'Views/Page/Content/Modal/Components';
import SearchableFinancialInstitutionQuerySelect
  from 'Components/ComponentLibrary/Components/Uncategorized/SearchableFinancialInstitutionQuerySelect';
import { FDAutoCompleteInput } from '@facet-wealth/design';

export const BalanceSheetAccountInfoOverride = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DialogTitle,
  }, overrideReadOnly)
  .nameOverride(['searchableFinancialInstitutionID'], {
    _component: () => SearchableFinancialInstitutionQuerySelect,
  }, overrideReadOnly)
  .nameOverride('accountSubType', {
    _component: () => FDAutoCompleteInput,
    _customProps: {
      fullWidth: true,
    },
  })
  .nameOverride('accountType', {
    hidden: true,
  }, overrideReadOnly);
